import { BASE_URL } from '../../config';

import {
    OPEN_PRINTER_MODAL,
    CLOSE_PRINTER_MODAL,
    GET_PRINTERS,
    ADD_PRINTER,
    UPDATE_PRINTER,
    DELETE_PRINTER
} from './printer.actionTypes';

import axios from 'axios';

import Notifier from '../../components/message/Notifier';

export const  addPrinter = (printer) => {
    return {
        type: ADD_PRINTER,
        printer
    };
}

export const  updatePrinter = (printer) => {
    return {
        type: UPDATE_PRINTER,
        printer
    };
}

export const  getPrinters = (printers) => {
    return {
        type: GET_PRINTERS,
        printers
    };
}

export const  deletePrinter = (printer) => {
    return {
        type: DELETE_PRINTER,
        printer
    };
}

export const  openPrinterModal = (printer) => {
    return {
        type: OPEN_PRINTER_MODAL,
        printer
    };
}

export const  closePrinterModal = () => {
    return {
        type: CLOSE_PRINTER_MODAL
    };
}

export const updatePrinterByApi = (id, printer) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}printer/${id}`, printer)
            .then((response) => {
                if (response.data) {
                    dispatch(updatePrinter(response.data));
                    Notifier.success('_printer_successfully_updated_', '_printer_updated_');
                }
            });
    };
};

export const addPrinterByApi = (printer) => {
    return (dispatch) => {
        axios.post(`${BASE_URL}printer/`, printer)
            .then((response) => {
                if (response.data) {
                    dispatch(addPrinter(response.data));
                    Notifier.success('_printer_successfully_added_', '_printer_added_');
                }
            });
    };
};

export const getPrintersByApi = () => {
    return (dispatch) => {
        axios.get(`${BASE_URL}printer/`)
            .then((response) => {
                if (response.data) {
                    dispatch(getPrinters(response.data));
                }
            });
    };
};

export const deletePrinterByApi = (id) => {
    return (dispatch) => {
        axios.delete(`${BASE_URL}printer/${id}`,)
            .then((response) => {
                if (response.data) {
                    dispatch(deletePrinter(response.data));
                    Notifier.success('_printer_successfully_deleted_', '_printer_deleted_');
                }
            });
    };
};

